import { SectionList as NbSectionList } from '@fhs-legacy/native-base';

import { addWithConfig } from '../../utils';

export const SectionList = NbSectionList;

export default addWithConfig(SectionList);
